import React from 'react';
import styled from '@emotion/styled';
import { DeckUI } from '@seedlang/state';
import { observer } from 'mobx-react';
import { useExampleSentenceTranslation } from '@seedlang/hoc';
import { cardAnswerFeedback } from '@seedlang/utils';
import { Theme } from '@seedlang/constants';

const Feedback = styled.div`
  display: flex;
  background-color: ${Theme.red};
  color: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 3px 20px;
  font-size: ${props => props.fontSize}px;
  text-align: center;
  white-space: nowrap;
  width: fit-content;
  max-width: ${props => props.hasTargetIcon ? 'calc(100% - 110px)' : '100%'};
  margin-inline: auto;
  flex-shrink: 0;
  margin-bottom: 4px;
`;

const ClippedText = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CardAnswerIndicator = ({ correct, userAnswer, text = cardAnswerFeedback(correct, userAnswer) }) => {
  const { canToggle } = useExampleSentenceTranslation();
  if (!text) return null;
  return (
    <Feedback hasTargetIcon={canToggle} role='status' fontSize={DeckUI.layout.minimumHeight ? 13 : 14}>
      <ClippedText>{text.slice(0, -1)}</ClippedText>
      <span>{text.slice(-1)}</span>
    </Feedback>
  );
};

export default observer(CardAnswerIndicator);
